import { render } from "./PptCourseware.vue?vue&type=template&id=71455fe7&scoped=true"
import script from "./PptCourseware.vue?vue&type=script&lang=js"
export * from "./PptCourseware.vue?vue&type=script&lang=js"

import "./PptCourseware.vue?vue&type=style&index=0&id=71455fe7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-71455fe7"

export default script